
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4d5bc2a96c0658018e6e.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					w.ready = new Promise(function(r) { w.addEventListener("ready", function(){ r(w) }) })
					return w
				}
			